import { useEffect, useState } from "react";
import axiosClient from "../../../../utils/api/axiosClient";
import { getToken } from "../../../../utils/functions";
import FormModel from "./models/FormModel";

export interface IQualification {
  id: number;
  name: string;
  code: string;
  status: boolean;
}

export const initialFormData = { id: 0, name: "", code: "", status: false };

function Qualification() {
  const [qualifications, setQualifications] = useState<IQualification[]>([]);
  const [initial, setInitial] = useState<IQualification>(initialFormData);

  useEffect(() => {
    const headers = { Authorization: getToken() };
    axiosClient.get("v1/qualifications", { headers }).then((res) => {
      if (res.status === 200) setQualifications(res.data);
    });
  }, []);

  const handleDelete = (id: number) => {
    const headers = { Authorization: getToken() };
    axiosClient.delete("v1/qualifications/" + id, { headers }).then((res) => {
      if (res.status === 200) setQualifications(res.data);
    });
  };

  const handleEdit = (qualification: IQualification) => {
    setInitial(qualification);
    setModalShow(true);
  };

  const handleCreate = () => {
    setInitial(initialFormData);
    setModalShow(true);
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <div className="app-content pt-3 p-md-3 p-lg-4">
      <div className="container-xl">
        <h1 className="app-page-title">Qualification</h1>
        <div className="row">
          <div className=" col-lg-12 ">
            <div className="card">
              <div className="card-header gutters-5">
                <h5 className="mb-md-0 h6">
                  All Qualification
                  <i
                    onClick={handleCreate}
                    className="fa fa-plus btn btn-sm pull-right"
                  ></i>
                </h5>
              </div>
              <div className="card-body">
                <table className="table aiz-table mb-0 footable footable-1 breakpoint-lg">
                  <thead>
                    <tr className="footable-header">
                      <th style={{ display: "table-cell" }}>#</th>
                      <th style={{ display: "table-cell" }}>Name</th>
                      <th style={{ display: "table-cell" }}>Code</th>
                      <th style={{ display: "table-cell" }}>Status</th>
                      <th
                        className="text-right"
                        style={{ display: "table-cell", width: "20%" }}
                      >
                        Options
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {qualifications.length ? (
                      qualifications.map((qualification, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{qualification.name}</td>
                            <td>{qualification.code}</td>
                            <td>{qualification.status ? "TRUE" : "FALSE"}</td>
                            <td>
                              <i
                                className="fa fa-pencil btn btn-sm"
                                onClick={() => handleEdit(qualification)}
                              ></i>
                              <i
                                className="fa fa-trash btn btn-sm"
                                onClick={() => handleDelete(qualification.id)}
                              ></i>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="footable-empty text-center">
                        <td colSpan={5}>Nothing Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="aiz-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormModel
        {...{ setQualifications, initial, setInitial, modalShow, setModalShow }}
      />
    </div>
  );
}

export default Qualification;
